import React from 'react';
import { Heart } from 'lucide-react';
import { Product } from '../../types';
import { formatCurrency } from '../../utils/formatters';

interface ProductCardProps {
  product: Product;
  onClick: (product: Product) => void;
  isWishlisted: boolean;
  onToggleWishlist: (e: React.MouseEvent) => void;
  onViewBrand?: (brandName: string) => void; // <--- The function to open brand profile
}

export const ProductCard: React.FC<ProductCardProps> = ({ 
  product, 
  onClick, 
  isWishlisted, 
  onToggleWishlist,
  onViewBrand
}) => {

  // Safety check for images
  const displayImage = product.images && product.images.length > 0 
    ? product.images[0] 
    : product.image || "https://via.placeholder.com/300";

  return (
    <div 
      onClick={() => onClick(product)}
      className="group relative flex flex-col gap-2 cursor-pointer"
    >
      {/* 1. Image Container */}
      <div className="aspect-[3/4] w-full overflow-hidden rounded-2xl bg-zinc-100 relative border border-black/5 dark:border-white/10 dark:bg-zinc-900">
        <img 
          src={displayImage} 
          alt={product.name}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        
        {/* Wishlist Button */}
        <button 
          onClick={(e) => {
            e.stopPropagation();
            onToggleWishlist(e);
          }}
          className="absolute top-2 right-2 p-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white hover:bg-white/20 active:scale-95 transition-all"
        >
          <Heart size={16} className={isWishlisted ? "fill-red-500 text-red-500" : "text-white"} />
        </button>

        {/* Price Tag */}
        <div className="absolute bottom-2 left-2 px-2 py-1 rounded bg-black/60 backdrop-blur-md border border-white/10">
          <span className="text-xs font-bold text-white">
            {product.price ? `R${product.price}` : 'R0'}
          </span>
        </div>
      </div>

      {/* 2. Product Details (Updated Order) */}
      <div className="mt-1 flex flex-col items-start gap-0.5">
        
        {/* A. PRODUCT NAME (First) */}
        <h3 className="font-bold text-sm leading-tight text-black dark:text-white truncate w-full">
          {product.name}
        </h3>

        {/* B. BRAND NAME (Second - Clickable) */}
        <button 
          onClick={(e) => {
            e.stopPropagation(); // Don't open the product details
            if (onViewBrand && product.brand) {
              onViewBrand(product.brand);
            }
          }}
          className="text-[10px] font-bold uppercase tracking-wider text-zinc-500 hover:text-orange-500 hover:underline dark:text-zinc-400 transition-colors text-left"
        >
          {product.brand || "Unknown Brand"}
        </button>
        
      </div>
    </div>
  );
};